import React from 'react';
import s from './s.module.less';
import { CheckOutlined } from '@ant-design/icons';

const Step1 = () => {
    const steps = [
        {
            id: 1,
            title: 'Create profile',
            status: 'completed',
        },
        {
            id: 2,
            title: 'Set up services',
            status: 'current',
        },
        {
            id: 3,
            title: 'List on Klarity Health',
            status: 'upcoming',
        },
        {
            id: 4,
            title: 'Configure availability',
            status: 'upcoming',
        },
    ];

    return (
        <div className={s.wrap}>
            <div className={s.content}>
                <div className={s.header}>
                    <h1>Let&apos;s set up your services for new patients</h1>
                    <p>
                        Next, we&apos;ll help you create clear bookable service so patients know exactly what you offer, your fees, and how they can book with confidence.
                    </p>
                </div>

                <div className={s.progressContainer}>
                    {steps.map((step, index) => (
                        <div key={step.id} className={s.stepWrapper}>
                            <div className={s.stepItem}>
                                <div className={`${s.stepIcon} ${s[step.status]}`}>
                                    {step.status === 'completed' ? (
                                        <CheckOutlined className={s.checkIcon} />
                                    ) : (
                                        <span className={s.stepNumber}>{step.id}</span>
                                    )}
                                </div>
                                <span className={`${s.stepTitle} ${s[step.status]}`}>
                                    {step.title}
                                </span>
                            </div>

                            {index < steps.length - 1 && (
                                <div className={`${s.connector} ${steps[index + 1].status === 'completed' ? s.completed : s.pending}`} />
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Step1;
